import { RefreshCw } from "lucide-react";
import { cn } from "../../../lib/utils";
import { useLocale } from "../../../context/LanguageContext";

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export function RefreshButton({
  onClick,
  loading = false,
  disabled = false,
}: RefreshButtonProps) {
  const { t } = useLocale();
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-1.5 text-sm font-medium text-foreground transition-colors",
        "hover:bg-muted disabled:cursor-not-allowed disabled:opacity-50",
      )}
    >
      <RefreshCw
        className={cn("h-4 w-4", loading && "animate-spin")}
      />
      {loading ? t("dashboard.refreshing") : t("common.refresh")}
    </button>
  );
}
